import { Link } from "react-router-dom";
import { mangaWorks } from "@/mocks/manga";

const updateTimes = ["2 小时前", "4 小时前", "6 小时前", "今天", "昨天", "前天"];

export default function Updates() {
  return (
    <section className="bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-8 flex items-end justify-between">
          <div>
            <p className="inline-flex items-center gap-2 text-sm text-accent-500">
              <i className="ri-refresh-line"></i> 本周更新
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              追更不迷路，更新一目了然
            </h2>
          </div>
        </div>

        <div className="overflow-hidden rounded-lg border border-background-200/60 bg-background-100">
          <div className="hidden grid-cols-12 gap-4 border-b border-background-200/70 bg-background-200/50 px-5 py-3 text-xs text-foreground-500 md:grid">
            <span className="col-span-5">作品</span>
            <span className="col-span-3">题材</span>
            <span className="col-span-3">最新更新</span>
            <span className="col-span-1 text-right">状态</span>
          </div>
          {mangaWorks.map((w, i) => (
            <Link
              key={w.id}
              to={`/work/${w.id}`}
              className="group grid grid-cols-1 items-center gap-2 border-b border-background-200/50 px-5 py-4 transition-colors last:border-0 hover:bg-background-200/40 md:grid-cols-12 md:gap-4"
            >
              <div className="col-span-1 flex items-center gap-4 md:col-span-5">
                <span className="hidden font-heading text-lg font-bold text-background-400 sm:block">{String(i + 1).padStart(2, "0")}</span>
                <span className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-500">{w.title}</span>
              </div>
              <span className="text-sm text-foreground-600 md:col-span-3">{w.categoryName}</span>
              <span className="inline-flex items-center gap-1.5 text-sm text-foreground-700 md:col-span-3">
                <i className="ri-arrow-right-up-line text-primary-500"></i>
                {w.latestChapter}
                <span className="whitespace-nowrap text-xs text-foreground-500">· {updateTimes[i % updateTimes.length]}</span>
              </span>
              <span
                className={`whitespace-nowrap text-right text-xs md:col-span-1 ${
                  w.status === "连载中" ? "text-accent-500" : "text-foreground-500"
                }`}
              >
                {w.status}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}